import Vue from 'vue'

const state = {
  sliders: {},
  loading: false,
  refCount: 0
}

const getters = {
  loading: state => state.loading,
  refCount: state => state.refCount,
  sliders: state => state.sliders
}

const mutations = {

  SET_LOADING (state, loading) {
    if (loading) {
      state.refCount++
      state.loading = loading
    } else {
      state.refCount--
      state.loading = loading
    }
    state.loading = state.refCount !== 0
  },
  SET_LOAD_IMAGES (state, payload) {
    state.sliders = payload
  }
}

const actions = {
  get_image_files ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        commit('app/SET_LOADING', true, { root: true })
        Vue.axios.get('get_images.php?katalog='+payload.dir+'&lang='+payload.lang)
          .then(response => response.data).then(results => {
            commit('SET_LOAD_IMAGES', results.data)
            commit('app/SET_LOADING', false, { root: true })
            resolve()
          })
          .catch((err) => {
            console.log(err)
            // reject()
          })
      }, 500)
    })
  },}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/app.js